import { useEffect, useState } from "react";
import { TListener } from "@/types";

type Header = {
  title: string;
};

let _header: Header = {
  title: "",
};

let listeners: TListener<Header>[] = [];

const updateListeners = () => {
  if (listeners.length > 0) {
    listeners.forEach((listener) => listener(_header));
  }
};

export const setTitle = (title: string) => {
  _header = { title };
  document.title = title;
  updateListeners();
};

export const useHeader = () => {
  const [state, setState] = useState(_header);
  useEffect(() => {
    listeners.push(setState);
    setState(_header);
    return () => {
      listeners = listeners.filter((listener) => listener !== setState);
    };
  }, []);
  return state;
};
